{{#if ready}}
    <div class="hpTestimonials-prehpTestimonials-xlarge-viewport">
        <h2 class="hpd2">Hear What Our Customers Are Saying</h2>
    </div>
    <div class="hpTestimonials-inner">
        <div class="hpTestimonials-inner-review">
            <div class="hpTestimonials-xlarge-viewport">
                <h2 class="hpd2">Hear What Our Customers Are Saying</h2>
            </div>
            <div class="hpTestimonials-inner-review-for">customer review for</div>
            <div class="hpTestimonials-inner-review-name">{{ productName }}</div>
            <div class="hpTestimonials-inner-review-score">
                {{#if rating}}
                    {{#ifEquals rating 5 }}
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                    {{/ifEquals}}
                    {{#ifEquals rating 4.75 }}
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_75"></div>
                    {{/ifEquals}}
                    {{#ifEquals rating 4.5 }}
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_50"></div>
                    {{/ifEquals}}
                    {{#ifEquals rating 4.25 }}
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_25"></div>
                    {{/ifEquals}}
                    {{#ifEquals rating 4 }}
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star_full"></div>
                        <div class="hpTestimonials-inner-review-score-star hpTestimonials-inner-review-score-star"></div>
                    {{/ifEquals}}
                {{/if}}
            </div>
            <div class="hpTestimonials-inner-review-copy"> {{ review }} </div>
            <div class="hpTestimonials-inner-review-user"> -{{ reviewer }} </div>
            <a class="hpTestimonials-inner-review-cta" href="{{ href }}"> Shop Now</a>
            <div class="dsPagination hpTestimonials-inner-review-pagination">
                <div class="dsPagination-indicator">
                    {{#each testimonials}}
                        <div class="dsPagination-indicator-page{{#if isCurrent }} isCurrent{{/if}}"></div>
                    {{/each}}
                </div>
                <div class="dsPagination-controls">
                    <div class="dsPagination-controls-prev js--action-testimonialPrev"></div>
                    <div class="dsPagination-controls-page">{{{ pagination }}}</div>
                    <div class="dsPagination-controls-next js--action-testimonialNext"></div>
                </div>
            </div>
        </div>
        <div class="hpTestimonials-inner-productImage" style="background-image: url('{{ productImg }}')"></div>
    </div>
{{/if}}
